module.exports = __webpack_public_path__ + "static/visual-art-studio-0cf528a901bf0393ac9cf68d8515cc80.jpg";